module.exports = __webpack_public_path__ + "static/img/logo_info.b3aa6d61.webp";